import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_HLWN_65: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PAGE_HLWN_65,
  },
  {
    pageId: PageId.CHAT_UPSELL_HLWN_65,
  },
  {
    pageId: PageId.UPSELL_HLWN_65,
  },
  {
    pageId: PageId.DOWNLOAD_HLWN_65,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
